import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppRoot from './AppRoot';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import PublicSharePage from './pages/PublicSharePage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import { BesokshanteringPage } from './kiosk';
import { ProvPage } from './prov';

// Suppress ResizeObserver errors globally - must be before React renders
const originalConsoleError = console.error;
console.error = (...args: any[]) => {
  if (
    typeof args[0] === 'string' &&
    (args[0].includes('ResizeObserver') || args[0].includes('ResizeObserver loop'))
  ) {
    return; // Suppress ResizeObserver errors
  }
  originalConsoleError.apply(console, args);
};

// Suppress ResizeObserver errors from window.onerror
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes('ResizeObserver')) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Route detection - check URL BEFORE any components load
const url = new URL(window.location.href);
const shareMatch = url.pathname.match(/^\/share\/([^/]+)\/?$/);
const isPublicShare = !!shareMatch;
const isResetPassword = url.pathname.includes('reset-password') || url.search.includes('token=');
const isBesokshantering = url.pathname.startsWith('/besokshantering');
const isProv = url.pathname.startsWith('/prov');

console.log('[index.tsx] Route detection:', { 
  pathname: url.pathname, 
  search: url.search, 
  isPublicShare, 
  isResetPassword,
  isBesokshantering,
  isProv 
});

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      {isBesokshantering ? (
        <BesokshanteringPage />
      ) : isProv ? (
        <ProvPage />
      ) : isResetPassword ? (
        <ResetPasswordPage onBackToLogin={() => { window.location.href = '/'; }} />
      ) : isPublicShare ? (
        <PublicSharePage shareToken={shareMatch![1]} />
      ) : (
        <AppRoot />
      )}
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
